<template>
  <TransitionGroup class="stack" name="stacked" tag="ul">
    <ScratchcardQuantityStackItem
      v-for="(n, index) in selectedQuantity"
      v-bind="{ index }"
      :key="n"
      class="stack-item"
      :size="DISPLAY_SIZE - REDUCE_SIZE_PER_INDEX * index"
      :style="{
        '--start-position': getShiftedPositionInPx(index - 1),
        '--end-position': getShiftedPositionInPx(index),
        'z-index': MAX_SELECTED_QUANTITY - index,
      }"
    />
  </TransitionGroup>
</template>

<script lang="ts" setup>
const DISPLAY_SIZE = 260
const REDUCE_SIZE_PER_INDEX = 8

const store = useScratchcardStore()
const { selectedQuantity } = storeToRefs(store)

const toPx = (n: number) => `${n}px`

const shiftedStackPositionInPx = computed(() =>
  toPx(selectedQuantity.value * -(REDUCE_SIZE_PER_INDEX / 4)),
)

const getShiftedPositionInPx = (index: number) =>
  toPx(REDUCE_SIZE_PER_INDEX * index)
</script>

<style lang="scss" scoped>
.stack {
  @include transition-default(transform);

  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  place-items: center;
  transform: translateX(v-bind(shiftedStackPositionInPx));

  &-item {
    grid-area: 1 / 1;
  }

  .stacked {
    &-enter-active {
      transition: transform $transition-duration-md $bezier-expressive-enter;
      transform: translateX(var(--start-position));
    }

    &-leave-active {
      transition: transform $transition-duration-md
        cubic-bezier(0.4, 0.14, 1, 1);
    }

    &-enter-to {
      transform: translateX(var(--end-position));
    }

    &-leave-to {
      transform: translateX(var(--start-position));
    }
  }
}
</style>
